module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "result bg-white a4"
  }, [_c('div', {
    staticClass: "result-title hidden-print__no"
  }, [_c('h1', [_vm._v("RELATÓRIO MÉDIA MÍNIMO X FIPE POR COMITENTES")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.period))]), _vm._v(" "), _c('div', {
    staticClass: "text-center hidden-print"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mostrarSalvados),
      expression: "mostrarSalvados"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mostrarSalvados) ? _vm._i(_vm.mostrarSalvados, null) > -1 : (_vm.mostrarSalvados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.mostrarSalvados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mostrarSalvados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mostrarSalvados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mostrarSalvados = $$c
        }
      }
    }
  }), _vm._v(" Mostrar veículos\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mostrarSucatas),
      expression: "mostrarSucatas"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.mostrarSucatas) ? _vm._i(_vm.mostrarSucatas, null) > -1 : (_vm.mostrarSucatas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.mostrarSucatas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mostrarSucatas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mostrarSucatas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mostrarSucatas = $$c
        }
      }
    }
  }), _vm._v(" Mostrar sucatas\n      "), _c('div', [_vm._v("Filtrar por comitente:\n        "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroComitente),
      expression: "filtroComitente"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroComitente = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Sem filtro")]), _vm._v(" "), _vm._l((_vm.comitentes), function(comitente) {
    return _c('option', {
      domProps: {
        "value": comitente
      }
    }, [_vm._v(_vm._s(comitente))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "text-center hidden-print"
  }, [_c('a', {
    on: {
      "click": _vm.print
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" imprimir "), _c('span', {
    staticClass: "font-thin"
  }, [_vm._v("(CTRL + P)")])])])]), _vm._v(" "), _vm._l((_vm.filteredData), function(comitente) {
    return _c('div', {
      staticClass: "c-result printer-page__no"
    }, [_c('h3', {
      staticClass: "comitente-nome text-uppercase"
    }, [_vm._v(_vm._s(comitente.nome))]), _vm._v(" "), _c('table', {
      staticClass: "tbl-result2"
    }, [_vm._m(0, true), _vm._v(" "), _vm._l((_vm.leiloesCData(comitente.leiloes)), function(leilao) {
      return ((leilao.type === 'Salvados' && _vm.mostrarSalvados) || (leilao.type === 'Sucatas' && _vm.mostrarSucatas) || (leilao.type === 'Total' && _vm.mostrarTotal) || leilao.type === 'header') ? _c('tr', [(leilao.type === 'header') ? _c('td', {
        staticClass: "font-bold"
      }, [_c('div', {
        staticClass: "m-t-xs"
      }, [_vm._v(_vm._s(_vm.semAno(leilao.data)))])]) : _vm._e(), _vm._v(" "), (leilao.type === 'header') ? _c('td') : _vm._e(), _vm._v(" "), (leilao.type === 'header') ? _c('td') : _vm._e(), _vm._v(" "), (leilao.type === 'header') ? _c('td') : _vm._e(), _vm._v(" "), (leilao.type === 'header') ? _c('td') : _vm._e(), _vm._v(" "), (leilao.type != 'header') ? _c('td', [_vm._v(_vm._s(_vm._f("translate")(leilao.type)))]) : _vm._e(), _vm._v(" "), (leilao.type != 'header') ? _c('td', [_vm._v(_vm._s(leilao.vendidos) + "/" + _vm._s(leilao.quantidade))]) : _vm._e(), _vm._v(" "), (leilao.type != 'header') ? _c('td', [_vm._v(_vm._s(_vm.an(leilao.percentualVenda)) + "%")]) : _vm._e(), _vm._v(" "), (leilao.type != 'header') ? _c('td', [_vm._v(_vm._s(_vm.an(leilao.percentualFipe)) + "%")]) : _vm._e(), _vm._v(" "), (leilao.type != 'header') ? _c('td', [_vm._v(_vm._s(_vm.an(leilao.percentualMinimoFipeVendidos)) + "%")]) : _vm._e(), _vm._v(" "), (leilao.type != 'header') ? _c('td', [_vm._v(_vm._s(_vm.an(leilao.percentualMinimoFipe)) + "%")]) : _vm._e()]) : _vm._e()
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Média (%) avaliação Comitente\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.an(comitente.salvadosMediaMinimoSobreFipe)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Média (%) Venda Leilão\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.an(comitente.salvadosMediaMinimoSobreFipeVendidos)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Total (R$) Avaliação Comitente\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(comitente.salvadosValorTotalMinimoPeriodo)))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Total (R$) Venda Leilão\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(comitente.salvadosValorTotalMinimoPeriodoVendidos)))])])]), _vm._v(" "), _vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Média (%) avaliação Comitente\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.an(comitente.sucatasMediaMinimoSobreFipe)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Média (%) Venda Leilão\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.an(comitente.sucatasMediaMinimoSobreFipeVendidos)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Total (R$) Avaliação Comitente\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(comitente.sucatasValorTotalMinimoPeriodo)))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Total (R$) Venda Leilão\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(comitente.sucatasValorTotalMinimoPeriodoVendidos)))])])]), _vm._v(" "), _vm._m(5, true), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Média Geral (%) avaliação Comitente\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.an(comitente.mediaMinimoSobreFipe)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Média Geral (%) Venda Leilão\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(_vm.an(comitente.mediaMinimoSobreFipeVendidos)) + "%")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Total  Geral Avaliação\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(comitente.valorTotalMinimoPeriodo)))])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right !important"
      },
      attrs: {
        "colspan": "5"
      }
    }, [_vm._v("\n          Total Geral Vendido\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v("R$" + _vm._s(_vm._f("moeda")(comitente.valorTotalMinimoPeriodoVendidos)))])])])], 2)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Vendidos")]), _vm._v(" "), _c('th', [_vm._v("% Venda")]), _vm._v(" "), _c('th', [_vm._v("% Fipe Venda")]), _vm._v(" "), _c('th', [_vm._v("% Min/Fipe Venda")]), _vm._v(" "), _c('th', [_vm._v("% Min/Fipe Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Veículos")])]), _vm._v(" "), _c('td', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "right !important"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("Sucatas")])]), _vm._v(" "), _c('td', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-589340c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/relatorios-basicos/components/ResultMediaFipeComitentesComMinimo.vue
// module id = 1707
// module chunks = 17